import { connect } from "react-redux";

import { getStudentIDList } from "state/school_money/selectors";

import EntityCarousel from "components/EntityCarousel";

/**
 * Allow swiping between students' pages.
 */
export default connect(
  (state, ownProps) => ({
    entityIDList: getStudentIDList(state),
    activeEntityID: ownProps.activeStudentID
  })
)(EntityCarousel);



// WEBPACK FOOTER //
// ./src/components/school_money/StudentCarousel.js